export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11680.ad918e76.jpg";